import React from 'react'
import { RegistrationForm } from './RegistrationForm'
import { SocialNetworks } from '../../emun/social'
import { useSocialNetworkAuthUser } from '../../api/mutations/useSocialNetworkAuthUser'

export const RegistrationFormContainer: React.FC = () => {
  const { socialNetworkAuthUser } = useSocialNetworkAuthUser()

  const onSocialAuth = (
    socialNetwork: SocialNetworks,
    callbackUrl?: string,
    appId?: number,
    lang?: string,
  ): Promise<any> =>
    socialNetworkAuthUser({
      socialNetwork,
      callbackUrl,
      appId,
      lang,
    }).then(({ data }: any) => {
      window.location.href = data.callbackUrl
    })

  return <RegistrationForm onSocialAuth={onSocialAuth} />
}

RegistrationFormContainer.displayName = 'RegistrationFormContainer'
